import React from 'react';

const WhatsAppButton = () => {
  const whatsappNumber = "5514996005922";
  const message = "Olá, vim pelo site da Fluxo Tech IA.";
  const href = whatsappNumber
    ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`
    : "#";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="whatsapp-float-button"
      aria-label="Falar no WhatsApp"
      onClick={(e) => {
        if (!whatsappNumber) {
          e.preventDefault();
          alert('Em breve nosso WhatsApp estará disponível!');
        }
      }}
    >
      <svg className="whatsapp-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.163 0 0 7.163 0 16c0 2.825.738 5.48 2.025 7.788L.05 31.95l8.313-2.018C10.609 31.23 13.208 32 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.5c-2.444 0-4.738-.663-6.713-1.813l-.481-.288-4.994 1.213 1.238-4.838-.319-.5A13.39 13.39 0 012.5 16C2.5 8.544 8.544 2.5 16 2.5S29.5 8.544 29.5 16 23.456 29.5 16 29.5z" fill="currentColor"/>
        <path d="M23.713 19.569c-.394-.2-2.331-1.15-2.694-1.281-.362-.131-.625-.2-.888.2-.262.4-1.019 1.281-1.25 1.544-.231.262-.462.294-.856.094-.394-.2-1.663-.613-3.169-1.956-1.169-1.044-1.962-2.331-2.194-2.725-.231-.394-.025-.606.175-.8.181-.181.394-.469.594-.706.2-.238.263-.4.394-.663.131-.263.066-.494-.031-.694-.1-.2-.888-2.137-1.219-2.925-.319-.769-.644-.663-.887-.675-.231-.013-.494-.013-.756-.013s-.694.1-1.056.494c-.363.394-1.382 1.35-1.382 3.294 0 1.944 1.413 3.819 1.613 4.081.2.263 2.788 4.256 6.75 5.969.944.406 1.681.65 2.256.831.95.3 1.813.256 2.494.156.762-.113 2.332-.956 2.663-1.875.331-.919.331-1.706.231-1.875-.1-.169-.362-.269-.756-.469z" fill="currentColor"/>
      </svg>
      <span className="whatsapp-pulse"></span>
    </a>
  );
};

export default WhatsAppButton;
